import { createNodeRuleSet, createVirtualModelNode, } from "@buildwithflux/models";
export function commonGenerate3DModelNode(footprintNodeUid, _bakedRules) {
    const modelNode = createVirtualModelNode(`${footprintNodeUid}_model`, footprintNodeUid, footprintNodeUid);
    modelNode.pcbNodeRuleSet = createNodeRuleSet({}, true);
    return [modelNode];
}
//# sourceMappingURL=common.js.map